export default "__VITE_PUBLIC_ASSET__3696f06b__"